import React from 'react';

const TermsConditions = () => {
	return (
		<div>
			<p>
				<b>RIZZBATES TERMS AND CONDITIONS</b>
			</p>
			<p>
				<b>PLEASE RETAIN A COPY OF THIS AGREEMENT FOR YOUR RECORDS</b>
			</p>
			<p>
				<b>
					THESE TERMS OF USE AND CONDITIONS OF SALE FORM A LEGALLY BINDING
					AGREEMENT (“AGREEMENT”) AND SHOULD BE READ CAREFULLY.
				</b>
				<b>&nbsp;</b>
			</p>
			<p>
				<b>
					THIS AGREEMENT CONTAINS ARBITRATION AND CLASS ACTION WAIVER PROVISIONS
					THAT WAIVE YOUR RIGHT TO A COURT HEARING OR JURY TRIAL OR TO&nbsp;
				</b>
				<b>
					PARTICIPATE IN A CLASS ACTION. ARBITRATION IS MANDATORY AND IS THE
					EXCLUSIVE REMEDY FOR ANY AND ALL DISPUTES.
				</b>
			</p>
			<p>
				<b>RIZZBATES TERMS AND CONDITIONS. </b>These Terms and Conditions apply
				to the RIZZBATES purchase of the person whose name or RIZZBATES number
				appears on the other side of this letter and/or any purchaser or user of
				the RIZZBATES service (“Service”) described herein (“YOU,” “You,” “you”,
				or “your“). RIZZBATES (“RIZZBATES”) is an optional service provided,
				administered, or owned and operated by SEMPRIS, LLC, and/or its
				subsidiaries and affiliates. SEMPRIS, 13033 Ridgedale Drive, Suite 202,
				Minnetonka MN 55305 (collectively, “SEMPRIS,” “We,” “Us” or “Our”).
			</p>
			<p>
				<b>THE SERVICE</b>. In exchange for payment by you of the current
				RIZZBATES fee, you may obtain RIZZBATES. The benefits of&nbsp; RIZZBATES
				consists of discounts and savings opportunities, including limitations
				on redemptions, as described on the other side of this letter and/or on
				the RIZZBATES website. SEMPRIS reserves the right to change the specific
				services included in the RIZZBATES website and reserves the right to
				modify these terms and conditions without notice. SEMPRIS reserves the
				right to limit discounts. SEMPRIS reserves the right to change the
				content of the RIZZBATES website at any time. We reserve the right to
				cancel your RIZZBATES purchase and access to the website and the Service
				at any time for any reason. No Service benefits carry over or may be
				used after cancellation by You or Us or more than twelve (12) months
				following your purchase date.
			</p>
			<p>
				<b>WHO MAY USE. </b>You must be a U.S. resident at least 18 years of age
				or the age of majority in your state of residence to purchase the
				Service. RIZZBATES is unavailable to residents of WI, IA, MN, UT and VT,
				and residents of FL, HI and NV are prohibited from receiving RIZZBATES
				benefits related solely to travel. Only you may use RIZZBATES for your
				benefit. If We discover that your RIZZBATES website or Service access
				has been used by or for someone other than you, or been compromised in
				any way, we reserve the right to cancel your access to the RIZZBATES
				website and the Service it provides, including the denial of any pending
				redemptions or purchases. No corporate, company, or business RIZZBATES
				purchases are permitted. You agree to notify Us if you become aware of
				any unauthorized use of your RIZZBATES purchase or website or Service
				access or if your RIZZBATES number is lost. This website is not directed
				at children under the age of 13. SEMPRIS does not intend to gather any
				personal information from children under 13.Children under the age of 18
				should get permission from a parent or guardian before sending any
				personal information to Us via e-mail or otherwise. However, if the
				parent or guardian of a child under 13 has provided Us with personally
				identifiable information, the parent or guardian of that child should
				call Us at 800-475-1942 if they want this information deleted from Our
				files.
			</p>
			<p>
				<b>RIZZBATES BILLING. </b>Your access to the RIZZBATES website and
				Service will begin on the date your purchase is recorded in our systems
				and will continue for a period of twelve (12) months thereafter unless
				and until you or We cancel. The card you provided at time of purchase,
				or any other current payment mechanism We have on file for you, will be
				automatically charged the price on the other side of this letter in four
				separate equal installments, the first of which will occur at&nbsp;the
				time of purchase, with the remaining three (3) installment payments
				billed within the twelve&nbsp;(12) month period during which you can
				access the website and use the Service. To cancel your RIZZBATES
				purchase and website access, write to P.O. Box 5265, Hopkins, MN
				55343-2265, Attn: Customer Service, or call 800-475-1942, or go to{' '}
				<a href='http://www.programstop.com/'>www.programstop.com</a> to cancel
				online. Also, see “Right to Cancel RIZZBATES” below.
			</p>
			<p>
				<b>PAYMENT METHOD. </b>You may edit your payment method information by
				calling Customer Service at 800-475-1942. If any payment is not
				successfully settled due to expiration, insufficient funds, or
				otherwise, and you do not edit your payment method information or cancel
				your purchase of or from RIZZBATES (See “Right to Cancel RIZZBATES”
				below), you remain responsible for any uncollected amounts and authorize
				Us to bill any payment method We have on file, as it may be updated.
				This may result in a change to your payment billing dates or a different
				card being charged for any of your purchases. We may update your payment
				method with information provided by the applicable payment service
				provider, and you authorize Us to continue to charge the RIZZBATES
				installment payment amount or any purchase you make from RIZZBATES to
				the updated payment method. If we are unable to successfully settle a
				payment for an installment, your access to the RIZZBATES website and
				Service will terminate after your paid period expires. For certain
				payment methods, the issuer of your payment method may charge you a
				foreign transaction fee or other charges. Check with your payment method
				service provider for details.
			</p>
			<p>
				<b>
					NO AUTOMATIC RENEWAL OR CONTINUATION OF SERVICE AFTER TWELVE (12)
					MONTHS
				</b>
				.&nbsp;Twelve (12) months after your purchase date, your access to the
				RIZZBATES website and Service will terminate. We may provide you the
				ability to purchase an additional twelve (12) months of RIZZBATES
				website and Service access, prior to their expiration, within the
				RIZZBATES website, or you may contact Customer Service at 800-475-1942
				to arrange for the purchase and payment.
			</p>
			<p>
				<b>RIGHT TO CANCEL RIZZBATES. </b>You have the right to cancel your
				RIZZBATES purchase at any time. To cancel, write to P.O. Box 5265,
				Hopkins, MN 55343-2265, Attn: Customer Service, or call 800-475-1942, or
				go to <a href='http://www.programstop.com/'>www.programstop.com</a> to
				cancel online. If you cancel your RIZZBATES purchase, you will not be
				charged any additional fees. When you cancel, access to the website and
				Service will end after your paid period has expired and any future
				RIZZBATES installment payment charges that would have been due will be
				cancelled.
			</p>
			<p>
				<b>LIABILITY. </b>SEMPRIS assumes no liability for any products or
				services provided by a SEMPRIS vendor or marketing partner. You agree
				that any claim shall be made against the vendor of such products or
				services and not SEMPRIS. This site may contain links to websites that
				are established and maintained by a party other than SEMPRIS. These
				links are provided for your convenience only, and We are not responsible
				for the content, accuracy or performance of such sites. SEMPRIS MAKES NO
				WARRANTY, EXPRESS OR IMPLIED, WITH RESPECT TO ANY PRODUCTS OR SERVICES
				SOLD OR INFORMATION DELIVERED OR PROVIDED TO YOU, INCLUDING ANY WARRANTY
				OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. SEMPRIS SHALL,
				UNDER NO CIRCUMSTANCES, BE LIABLE FOR CONSEQUENTIAL OR INCIDENTAL
				DAMAGES. OUR LIABILITY TO YOU SHALL IN NO EVENT EXCEED THE AMOUNT OF THE
				RIZZBATES FEE YOU PAID. SOME STATES DO NOT ALLOW THE EXCLUSION OR
				LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE
				LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU. NOTWITHSTANDING ANYTHING
				IN THESE TERMS TO THE CONTRARY, THIS LIMITATION OF LIABILITY AND
				DISCLAIMER OF WARRANTY DOES NOT APPLY IN NEW JERSEY.
			</p>
			<p>
				<b>ARBITRATION AND DISPUTES. </b>This Agreement and any issue or dispute
				arising out of or otherwise related to this Agreement or with your use
				of Our website, the Privacy Policy, or any&nbsp;matter concerning
				SEMPRIS including use and purchase of RIZZBATES, collectively
				“Disputes,” shall be governed exclusively by the laws of the State of
				Minnesota, excluding its conflict of law provisions. If a Dispute arises
				under this Agreement, we agree to first contact each other with a
				written description of the Dispute, all relevant documents and
				information, and the proposed resolution.
			</p>
			<p>
				You agree to contact Us with Disputes by writing to Us at SEMPRIS, 13033
				Ridgedale Drive, Suite 202, Minnetonka MN 55305. SEMPRIS will contact
				you by letter to your billing address you provided Us.
			</p>
			<p>
				If any Dispute cannot be resolved informally, we each agree that any and
				all Disputes, other than those either party may choose to file in small
				claims court, shall be submitted to final and binding arbitration before
				a single arbitrator under the auspices of JAMS® in a location convenient
				to you. Either party may commence the arbitration process by submitting
				a written demand for arbitration with JAMS® and providing a copy to the
				other party. The arbitration will be conducted in accordance with the
				provisions of the JAMS® Consumer Arbitration Minimum Standards in effect
				at the time of submission of the demand for arbitration (available at{' '}
				<a
					href='https://www.jamsadr.com/consumer-minimum-standards/'
					target='_blank'
					rel='noreferrer'
				>
					www.jamsadr.com/consumer-minimum-standards
				</a>
				), which are incorporated by reference herein. We will pay all of the
				filing costs, including arbitrator fees. Judgment on the award rendered
				by the arbitrator may be entered in any court of competent
				jurisdiction.&nbsp;Notwithstanding the foregoing, the following shall
				not be subject to arbitration and may be adjudicated only in the state
				and federal courts of Minnesota: (i) any dispute, controversy, or claim
				relating to or contesting the validity of our proprietary rights,
				including without limitation, trademarks, service marks, copyrights, or
				trade secrets; or (ii) an action by a party for temporary, preliminary,
				or permanent injunctive relief, whether prohibitive or mandatory, or
				other provisional relief.{' '}
				<b>
					You expressly agree to refrain from bringing or joining any claims in
					any representative or class-wide capacity, including but not limited
					to bringing or joining any claims in any class action or any
					class-wide arbitration.
				</b>
			</p>
			<p>
				<b>
					YOU UNDERSTAND THAT YOU WOULD HAVE HAD A RIGHT TO LITIGATE THROUGH A
					COURT, TO HAVE A JUDGE OR JURY DECIDE YOUR CASE AND TO BE PARTY TO A
					CLASS OR REPRESENTATIVE ACTION. HOWEVER, YOU UNDERSTAND AND CHOOSE TO
					HAVE ANY CLAIMS DECIDED INDIVIDUALLY AND ONLY THROUGH ARBITRATION.
				</b>
			</p>
			<p>
				<b>MAIL PREFERENCE SERVICE. </b>From time to time, We make portions of
				Our customer list available to carefully screened companies and
				organizations whose products or services may be of interest to you. If
				you would prefer to have your name withheld, please send your request
				with complete name and mailing address to:{' '}
				<b>Mail Preference Service, P.O. Box 5265, Hopkins, MN 55343-2265</b>.
			</p>
			<p>
				<b>QUESTIONS. </b>If you have any questions regarding RIZZBATES, please
				call Us toll free at 800-475-1942.
			</p>
			<p>
				<b>A NOTE TO OUR CUSTOMERS: </b>If at any time you have trouble placing
				or receiving an order or using the RIZZBATES website or Service, please
				contact one of Our customer service specialists at 800-475-1942, or
				email Us at <a href='mailto:support@sempris.com'>support@sempris.com</a>{' '}
				for assistance.
			</p>{' '}
		</div>
	);
};

export default TermsConditions;
